import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytes,
} from "firebase/storage";
import { storage } from "../firebase/firebase";
import { useState } from "react";
import { message } from "antd";

export const useUpload = () => {
  const [loading, setLoading] = useState(false);
  const imageUrls = []; // deposit array
  // async task to upload images
  const uploadImages = async (images, path, callback, isUpdate = false) => {
    // if updating and array is empty
    if (images.length === 0 && isUpdate) return;

    if (images.length === 0)
      return message.error("Select atleast one product image");

    setLoading(true);
    for await (const image of images) {
      const file = image.file;
      const storageRef = ref(storage, `/${path}/${file.lastModified}`);
      await uploadBytes(storageRef, file);
      const imageUrl = await getDownloadURL(storageRef);
      imageUrls.push(imageUrl); // send url to array
    }
    setLoading(false);
    if (callback) return callback();
  };
  // delete images
  const deleteImages = async (delArray) => {
    // if delete array not empty
    if (delArray.length === 0) return;
    setLoading(true);
    for await (const imageUrl of delArray) {
      const imageRef = ref(storage, imageUrl);
      deleteObject(imageRef).catch((err) => console.log(err));
    }
    setLoading(false);
  };
  return { imageUrls, uploadImages, deleteImages, loading };
};
